import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { SmartLockProvider } from '../../providers/smart-lock/smart-lock';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-smart-lock-log',
  templateUrl: 'smart-lock-log.html',
})
export class SmartLockLogPage {
  requestStatus = [];
  constructor(public navCtrl: NavController,private translate: TranslateService, public navParams: NavParams,private smartLockProvider: SmartLockProvider, ) {
    this.smartLockLog(null);
  }

  smartLockLog(lockData: any){
    this.smartLockProvider.requestStatus(lockData).then((val:any) =>{
      if(val.status == 'success'){
        val.data.forEach(element => {
          let data1= JSON.parse(element.data);
          element.data = data1;
        });
        console.log(val.data);
        this.requestStatus = val.data;
      }
    }).catch(error => {
      console.log(error);
    });
  }

  doRefresh(refresher) {
    this.smartLockLog(null);
    refresher.complete();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SmartLockLogPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/smart-lock-log/smart-lock-log.ts